import { Box } from '@chakra-ui/react'

export default function PageLoader(): JSX.Element {
  return (
    <Box
      minH="100vh"
      p={0}
      m={0}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bgAttachment={'fixed'}
      bgSize={'cover'}
      bgRepeat={'no-repeat'}
      bgPos={'0 0'}
      bgImage={"url('/static/app-bg.jpg')"}
    />
  )
}
